__turbopack_context__.v({
  "chevron-up-icon": "ChevronUp-module-scss-module__ZzLoRW__chevron-up-icon",
});
